<template>
  <div class="file-template-breadcrumb">
    <template v-if="!isSearch">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-list"
      >
        <el-breadcrumb-item @click.native="gotoFolder()"
          >模板库</el-breadcrumb-item
        >
        <el-breadcrumb-item
          v-if="moreBreadcrumbList && moreBreadcrumbList.length"
        >
          <el-dropdown :trigger="tools.isPC() ? 'hover' : 'click'">
            <span class="more-item"> ... </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="option in moreBreadcrumbList"
                :key="option.label"
                @click.native="gotoFolder(option.folder_token)"
                >{{ option.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="lastBreadcrumb">{{
          lastBreadcrumb.label
        }}</el-breadcrumb-item>
      </el-breadcrumb>

      <button
        class="back-btn"
        @click="gotoPreFolder"
        v-if="breadcrumbList.length"
      >
        返回
      </button>
    </template>

    <template v-else>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-list"
      >
        <el-breadcrumb-item @click.native="gotoFolder()"
          >模板库</el-breadcrumb-item
        >

        <el-breadcrumb-item>搜索</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
  </div>
</template>

<script>
import tools from '@/services/tools';

export default {
  props: {
    value: {
      type: String,
    },
    breadcrumbList: {
      type: Array,
      default: () => [],
    },
    // 是否是搜索结果
    isSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tools,
    };
  },
  computed: {
    innerFolderToken: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    lastBreadcrumb() {
      return this.breadcrumbList[this.breadcrumbList.length - 1];
    },
    moreBreadcrumbList() {
      const moreBreadcrumbList = this.breadcrumbList.slice(
        0,
        this.breadcrumbList.length - 1,
      );
      return moreBreadcrumbList;
    },
  },
  methods: {
    gotoFolder(folderToken) {
      this.innerFolderToken = folderToken;
      this.$emit('update');
    },
    // 返回上一级
    gotoPreFolder() {
      let token;
      if (this.breadcrumbList.length > 1) {
        token =
          this.breadcrumbList[this.breadcrumbList.length - 2].folder_token;
      }
      this.gotoFolder(token);
    },
  },
};
</script>

<style lang="less" scoped>
.file-template-breadcrumb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .breadcrumb-list {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
  }
  .more-item {
    cursor: pointer;
  }
  .back-btn {
    flex-shrink: 0;
    font-size: 14px;
    color: #3fa2f5;
    line-height: 14px;
    cursor: pointer;
    background: transparent;
    border: none;
    position: relative;
    left: 10px;
  }
}
</style>
